import { type FC, type PropsWithChildren } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, type ButtonProps } from 'base-ui'

import { useCopyText } from '../../../generic-hooks'

interface Props extends ButtonProps {
  textToCopy: string
}

export const StoryblokVoucherCardButtonCopy: FC<PropsWithChildren<Props>> = ({
  children,
  textToCopy,
  ...rest
}) => {
  const { copied, copyText } = useCopyText(textToCopy)

  return copied ? (
    <span className="text-l text-dark-pressed-success-medium">
      <FormattedMessage id="voucherBox.input.copiedLabel.button" />
    </span>
  ) : (
    <Button
      onClick={(): void => {
        void copyText()
      }}
      {...rest}
    >
      {children}
    </Button>
  )
}
